 import React from "react";
import LevelIcon from "../../../../../../images/membership/level-blue.svg";
import LockIcon from "../../../../../../images/membership/grey-lock.svg";
import { Col, Row, Table } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import MembershipStore from "../MembershipStore";  
import { CollapsiblePanel, CustomLabel, FlexContainer, SingleSelect, StatusCircle, StyledTable } from "@mindmemobile/mm-shared-global";
import { MembershipOptionsPageInputModel, PriceProgramAndLevelsMappingModel } from "../../../shared/models";

type Props = {
  membershipStore?: MembershipStore;
};
@inject('membershipStore')
@observer
export default class ProgramAndLevels extends React.Component<Props> {
  get optionsPageData() {
      return this.props.membershipStore?.optionsPage;
  }
  getProgramOptions() {
      const options =
          this.props.membershipStore?.programAndLevelsService?.programAndLevels?.map((program) => {
              return { label: program.name, value: program.id };
          }) || [];

      options.splice(0, 0, { label: 'No Program', value: '' });
      return options;
  }

  getProgramLevelOptions(programId: string) {
      const programs =
          this.props.membershipStore?.programAndLevelsService?.programAndLevels?.filter((p) => p.id === programId) ||
          [];

      if (programs.length > 0) {
          return programs[0].levels.map((level) => {
              return { label: level.name, value: level.id };
          });
      }
      return [];
  }

  select(hasError: boolean, selectedKey: string, options: any[], onChange: (id: string) => void) {
      return (
          <SingleSelect
              hasError={hasError}
              selectedKey={selectedKey}
              nameKeys={['label']}
              valueKeys={['value']}
              onChange={(option) => onChange(option.value)}
              options={[options]}
              className="option-table-select"
          />
      );
  }

  get clonedProgramAndLevels() {
      return (
          this.optionsPageData?.programAndLevels?.map((programAndLevel) => {
              return new PriceProgramAndLevelsMappingModel({
                  ...programAndLevel,
              });
          }) || []
      );
  }
  onChange(index: number, id: string, isProgram: boolean) {
      const clonedProgramAndLevels = this.clonedProgramAndLevels;
      const programToUpdate = clonedProgramAndLevels[index];
      if (isProgram) {
          programToUpdate.programId = id;
      } else {
          programToUpdate.levelId = id;
      }

      const clonedOptionsPage = new MembershipOptionsPageInputModel({
          ...this.optionsPageData,
          programAndLevels: clonedProgramAndLevels,
      });
      this.props.membershipStore?.updateOptionsPage(clonedOptionsPage);
  }

  render() {
      return (
          <CollapsiblePanel title="Program & Level" className="collapsed-labels setup" imgSrc={LevelIcon}>
              <Row className="padding-left-40">
                  <Col md={12}>
                      <CustomLabel>
                          Add Contact to a Program & Level when this Membership is sold. Select for each Pricing Plan.
                      </CustomLabel>
                  </Col>
              </Row>
              <StyledTable className="program-table padding-left-40" width="1290px">
                  <Table bsPrefix="styled-table" responsive>
                      <thead>
                          <th className="text-center">STATUS</th>
                          <th className="text-center">LOCKED</th>
                          <th>PRICING</th>
                          <th>PROGRAM</th>
                          <th>STARTING LEVEL</th>
                          <th></th>
                      </thead>
                      <tbody>
                          {this.optionsPageData?.programAndLevels?.map((pl, index) => {
                              return (
                                  <tr key={index}>
                                      <td>
                                          <FlexContainer justifyContent="center">
                                              <StatusCircle inActive={!pl.isActivePrice} />
                                          </FlexContainer>
                                      </td>
                                      <td className="text-center">
                                          <img src={LockIcon} className="option-lock" />
                                      </td>
                                      <td className="pricing-option">
                                          <CustomLabel>{pl.priceName} </CustomLabel>
                                      </td>
                                      <td>
                                          {this.select(
                                              pl.hasError('programId'),
                                              pl.programId,
                                              this.getProgramOptions(),
                                              (id: string) => this.onChange(index, id, true),
                                          )}
                                      </td>
                                      <td>
                                          {pl.programId &&
                                              this.select(
                                                  pl.hasError('levelId'),
                                                  pl.levelId,
                                                  this.getProgramLevelOptions(pl.programId),
                                                  (id: string) => this.onChange(index, id, false),
                                              )}
                                      </td>
                                      <td></td>
                                  </tr>
                              );
                          })}
                      </tbody>
                  </Table>
              </StyledTable>
          </CollapsiblePanel>
      );
  }
}
